<template>
  <v-flex :class="['caption', align]" shrink>
    <span :class="['probability-capsule', colorClass]">{{ label }}</span>
  </v-flex>
</template>

<script>
export default {
  props: {
    probability: {
      type: String,
      required: true
    },
    /**
     * Align the probability.
     */
    align: {
      type: String,
      default: "text-xs-right"
    }
  },
  computed: {
    label() {
      return this.probability;
    },
    colorClass() {
      const colorMap = {
        'Excelente': 'excellent',
        'Muy Bueno': 'very-good',
        'Bueno': 'good',
        'Regular': 'fair',
        'Bajo': 'poor',
        'Muy Bajo': 'very-poor',
        'Sin Coincidencia': 'no-match'
      };
      return colorMap[this.probability] || 'no-match';
    }
  }
};
</script>

<style scoped>
.probability-capsule {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.75rem;
  white-space: nowrap;
}

.excellent {
  background-color: #c8e6c9;
  color: #2e7d32;
  font-weight: 600;
}

.very-good {
  background-color: #dcedc8;
  color: #558b2f;
  font-weight: 500;
}

.good {
  background-color: #e7f4d9;
  color: #689f38;
}

.fair {
  background-color: #fff9c4;
  color: #f57f17;
}

.poor {
  background-color: #ffe0b2;
  color: #e65100;
}

.very-poor {
  background-color: #ffccbc;
  color: #d84315;
}

.no-match {
  background-color: #eceff1;
  color: #607d8b;
  font-style: italic;
}
</style>